import classNames from 'classnames';

export const Notification = () => {
  return (
    <div className={classNames('relative', 'w-2', 'h-2', 'bg-feedback-error', 'rounded-full', 'ml-2', 'mr-1')}>
      <div
        className={classNames(
          'absolute',
          'w-full',
          'h-full',
          'bg-feedback-error-medium',
          'rounded-full',
          'animate-highlight',
          '-z-1',
        )}
      />
    </div>
  );
};
